<template>
  <v-dialog v-model="showModal" max-width="500" persistent transition="false">
    <v-card class="elevation-8 blue lighten-5">
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon color="grey">mdi-window-close</v-icon>
        </v-btn>
      </v-card-actions>
      <v-card-title class="justify-center">
        <h3
          v-if="!isMobile && !user.premium"
          class="text-xs-center display-1 indigo--text text--darken-4 font-weight-bold"
        >
          Go Premium for Only $9.99 Per Year!
        </h3>
        <h3
          v-else-if="isMobile && !user.premium"
          class="text-xs-center display-1 indigo--text text--darken-4 font-weight-bold"
        >
          Download the Pool Calculator App!
        </h3>
      </v-card-title>
      <v-card-text>
        <h3
          v-if="!isMobile && !user.premium"
          class="ml-5 mr-5 text-xs-center indigo--text text--darken-4 font-weight-regular"
        >
          Enjoy an ad-free experience, record your test history, and log your
          chemical history for an unlimited number of pools!
        </h3>
        <h3
          v-else-if="isMobile && !user.premium"
          class="ml-5 mr-5 text-xs-center indigo--text text--darken-4 font-weight-regular"
        >
          Use the native Pool Calculator App for a seamless experience on your
          smartphone!
        </h3>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          v-if="!isMobile && !user.premium"
          color="red"
          class="premium white--text font-weight-bold mb-4"
          @click="$router.push('account/billing')"
          >Go Premium!</v-btn
        >
        <v-row v-else-if="isMobile && !user.premium">
          <v-col class="mr-2">
            <a
              href="https://itunes.apple.com/us/app/pool-calculator/id412876581?mt=8"
              target="_blank"
            >
              <img
                :src="require('@/assets/app-store2.svg')"
                alt="iOS App"
                contain
                width="120px"
              />
            </a>
          </v-col>
          <v-col class="ml-2">
            <a
              href="https://play.google.com/store/apps/details?id=com.psiflow.poolcalculator&hl=en_US"
              target="_blank"
            >
              <img
                :src="require('@/assets/play-store2.svg')"
                alt="Android App"
                contain
                width="120px"
              />
            </a>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "PCModal",
  data() {
    return {
      day: 86400000,
      showModal: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "user/getUser",
    }),
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
  },
  methods: {
    close() {
      this.showModal = false;
      localStorage.setItem("modalStatus", this.showModal);
      this.setModalRefresh();
    },
    setModalRefresh() {
      let lastClear = localStorage.getItem("lastclear");
      let timeNow = new Date().getTime();

      if (localStorage.getItem("modalStatus") === "true") {
        setTimeout(() => {
          this.showModal = !this.user.premium;
        }, 30000);
      }

      if (timeNow - lastClear > this.day) {
        localStorage.setItem("lastclear", timeNow);
        localStorage.setItem("modalStatus", true);
      }
    },
  },
  mounted() {
    this.setModalRefresh();
  },
};
</script>
